import { type TypedDocumentNode, useQuery } from "@apollo/client";
import { useEffect } from "react";

import { errorHandling } from "../apollo/utils";

const INSURANCE_CHECK_POLL_INTERVAL_MS = 2_500;

/** Polls while `polling` until `landed`; a failed poll doesn't stop it. */
export function useInsuranceCheckPoll<TData>(
  query: TypedDocumentNode<TData, Record<string, never>>,
  {
    polling,
    landed,
    intervalMs = INSURANCE_CHECK_POLL_INTERVAL_MS,
  }: {
    polling: boolean;
    landed: (data: TData) => boolean;
    intervalMs?: number;
  },
) {
  const { data, error, stopPolling } = useQuery(query, {
    skip: !polling,
    fetchPolicy: "network-only",
    pollInterval: intervalMs,
    context: errorHandling("caller"),
  });
  const done = data !== undefined && landed(data);
  useEffect(() => {
    if (done) {
      stopPolling();
    }
  }, [done, stopPolling]);
  return { data, error };
}
